import { render, staticRenderFns } from "./BaseContainerLoading.vue?vue&type=template&id=0dd5d36a"
import script from "./BaseContainerLoading.vue?vue&type=script&lang=js"
export * from "./BaseContainerLoading.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports